//项目转合同弹窗
<template>
  <div class="dialog-body">
    <el-dialog title="项目转合同确认" :visible.sync="dialogVisible" append-to-body width="30%">
      <div class="result">
        <el-row :gutter="24">
          <el-col :span="24">
            <span style="text-align: center; display: block">请选择要转换为的合同类型</span>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-form
            :model="dialogData"
            :rules="rules"
            ref="dialogForm"
            label-width="100px"
            style="margin-top: 20px"
          >
            <el-form-item label="合同类型">
              <el-select
                v-model="dialogData.type"
                placeholder="请选择"
                label=""
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in types"
                  :label="item.label"
                  :value="item.value"
                  :key="index"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t('cooperation.buttons.cancel') }}</el-button>
        <el-button type="primary" @click="handleSure">生成合同</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: 'ProjectToContractDialog',
    data() {
      return {
        dialogVisible: false,
        types: [
          { label: '供方合同', value: '1' },
          { label: '客户合同', value: '0' },
        ],
        dialogData: { type: '1' },
        rules: {
          type: [
            {
              required: true,
              message: '请选择',
              trigger: ['blur', 'change'],
            },
          ],
        },
      };
    },
    methods: {
      openDialog() {
        this.dialogVisible = true;
      },
      handleClose() {
        this.dialogVisible = false;
      },
      handleSure() {
        this.$refs['dialogForm'].validate((valid) => {
          if (valid) {
            this.dialogVisible = false;
            this.$emit('handleSure', this.dialogData.type);
          }
        });
      },
    },
  };
</script>

<style scoped>
  ::v-deep .el-dialog__footer {
    text-align: center;
  }

  .el-dialog .el-dialog__body {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .dialog-body {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }

  .result {
    padding: 20px 100px 20px 100px;
  }

  ::v-deep .el-dialog__footer {
    text-align: center;
  }
</style>
